export default "__VITE_ASSET__sGyyecbb__"